import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'seo-suppliers_page_visual_nav_carousel-view';

/**
 * tracking visual nav carousel view for suppliers brand results page

parameter: category link
 */
export function trackSeoSuppliersPageVisualNavCarouselView(
  customParameterToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { customParameterToken },
  });
}
